import { useCallback, useEffect, useState } from 'react';

/** Záložky se nevejdou: součet šířek záložek je větší než šířka kontejneru (1 px tolerance na zaokrouhlení). */
export const zalozkyPretecou = (sirkyZalozek: number[], sirkaKontejneru: number): boolean =>
    sirkaKontejneru > 0 && sirkyZalozek.reduce((a, b) => a + b, 0) > sirkaKontejneru + 1;

/**
 * Šipky posunu záložek jen při skutečném přetečení (E8). MUI `scrollButtons="auto"` rozhoduje přes IntersectionObserver
 * a po změně šířky okna (úzké → široké) nechá šipku viditelnou, i když se záložky vejdou. Přetečení proto měříme sami
 * (šířky záložek proti šířce kontejneru bez šipek) a vracíme hodnotu pro `scrollButtons`: `'auto'` při přetečení, jinak `false`.
 */
export const usePreteceZalozek = (): { ref: (el: HTMLElement | null) => void; scrollButtons: 'auto' | false } => {
    const [kontejner, setKontejner] = useState<HTMLElement | null>(null);
    const [pretece, setPretece] = useState(false);
    const ref = useCallback((el: HTMLElement | null) => setKontejner(el), []);

    useEffect(() => {
        if (!kontejner) return undefined;
        const zmer = () => {
            const zalozky = Array.from(kontejner.querySelectorAll<HTMLElement>('[role="tab"]'));
            setPretece(zalozkyPretecou(zalozky.map((z) => z.getBoundingClientRect().width), kontejner.clientWidth));
        };
        zmer();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const ro = new ResizeObserver(zmer);
        ro.observe(kontejner);
        kontejner.querySelectorAll('[role="tab"]').forEach((z) => ro.observe(z));
        return () => ro.disconnect();
    }, [kontejner]);

    return { ref, scrollButtons: pretece ? 'auto' : false };
};
